import { Link } from "react-router-dom";

import { cn } from "@/lib/cn";

import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/Icon";
import { Logo } from "@/components/ui/Logo";
import { ROUTES } from "@/constants/routes";

interface LandingHeaderProps {
  showButton?: boolean;
}

export const LandingHeader = ({ showButton = true }: LandingHeaderProps) => (
  <header
    className={cn(
      "fixed top-0 right-0 left-0 z-50 flex items-center justify-between",
      "px-4 py-4 md:py-5",
      "header-blur bg-neutral-950/40 shadow-[0_8px_32px_color-mix(in_srgb,var(--color-neutral-950)_60%,transparent)] backdrop-blur-xl"
    )}
  >
    <Logo />
    <div
      className={cn(
        "transition-all duration-300",
        showButton ? "translate-y-0 opacity-100" : "pointer-events-none -translate-y-2 opacity-0"
      )}
    >
      <Button
        variant="white"
        size="lg"
        asChild
      >
        <Link to={ROUTES.register}>
          <Icon name="logo" />
          Запустить бота
        </Link>
      </Button>
    </div>
  </header>
);
